import type { AppState, GetterClass } from '../../../models'

export class LoadingGetter implements GetterClass {
  static execute(this: void, state: AppState): AppState['loading'] {
    return state.loading
  }
}
